import Post from '../api'
//标签列表
export const GetUserTagList = (param: object): any => {
    return Post('GetUserTagList', param)
}

//标签列表
export const SetUserTag = (param: object): any => {
    return Post('SetUserTag', param)
}

//获取管理员
export const GetPuidList = (param: object): any => {
    return Post('GetPuidList', param)
}

//发送红包
export const SendRewardpack = (param: object): any => {
    return Post('SendRewardpack', param)
}
// 红包管理界面列表
export const GetRewardpackList = (param: object): any => {
    return Post('GetRewardpackList', param)
}
// 白名单玩家列表
export const GetWhiteUidList = (param: object): any => {
    return Post('GetWhiteUidList', param)
}
// 添加白名单玩家
export const AddWhiteUid = (param: object): any => {
    return Post('AddWhiteUid', param)
}
// 白名单批量删除
export const UpdateWhiteUid = (param: object): any => {
    return Post('UpdateWhiteUid', param)
}
